import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, AnimationEvent, state, style, transition, trigger} from "@angular/animations";
import {slideInUpOnEnterAnimation} from "@app/animation/slideDownToUp";

@Component({
  selector: 'navaar-sort-list',
  templateUrl: './sort-list.component.html',
  styleUrls: ['./sort-list.component.scss'],
  animations: [
    trigger("overlayAnimation", [
      state(
        "void",
        style({
          opacity: 0,
        })
      ),
      state(
        "visible",
        style({
          opacity: 1,
        })
      ),
      transition("* => *", animate("300ms cubic-bezier(0.25, 0.8, 0.25, 1)")),
    ]),
    slideInUpOnEnterAnimation({anchor: "slidePopup", duration: 250})
  ]
})
export class SortListComponent implements OnInit {
  @Input() public container: HTMLDivElement;
  @Input() public visible: boolean = false;
  @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output('select-sort') public selectSort: EventEmitter<{ title: string, type: string }> = new EventEmitter<{ title: string, type: string }>();

  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  public sortSelectIndex = 0;
  private SWIPE_ACTION = {DOWN: "swipedown"};
  public AnimationSortListScrollbar: string;
  public sortList = [
    {
      title: "تازه ترین",
      type: "CreateDate desc",
    },
    {
      title: "قدیمی ترین",
      type: "CreateDate",
    },
    {
      title: " حروف الفبا",
      type: "Title",
    }
  ];
  constructor() { }

  ngOnInit(): void {  }


  public swipe(action: string) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.onClose();
    }
  }

  public onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.AnimationSortListScrollbar = "void";
  }

  public onSortListScrollbar(event: AnimationEvent) {
    if (event.toState === "void") {
      this.AnimationSortListScrollbar = "";
    }
  }

  public selected(i, item) {
    this.sortSelectIndex = i;
    this.selectSort.emit(item);
  }

  public onOverlayAnimationStart(event: AnimationEvent) {
    if (event.toState === "visible") {
      this.container = event.element;
    }
  }
}
